export default __webpack_public_path__ + "static/media/BackupEcoV2.e75f52e4.png";